export default __webpack_public_path__ + "static/runway-03-8fae3bbee290efe488b95f2b93597466.mp4";